import { useEffect } from 'react';
import { useCertificateTypes } from '../../certificate-types/hooks/useCertificateTypes';
import { CERTIFICATES_STATUS } from '../../../interaces/certificates_types.interface';
import { formatOptionsForSelect } from '../../../services/helpers';
import { useDataTable } from '../../../hooks/useDataTable';
import { ENUM_MODULES } from '../../../interaces/enums/enums.interface';
import { reportsApi } from '../api/reports.api';

const EMPTY_CUSTOMER_FILTERS = [];

export const useReports = (module = ENUM_MODULES.REPORTS, customerFilters = EMPTY_CUSTOMER_FILTERS) => {
  const table = useDataTable(reportsApi);
  const { setDataFilters } = table;
  const {
    names,getNames
  } = useCertificateTypes();



  useEffect(() => {
      if (module !== ENUM_MODULES.REPORTS) return;
      getNames()
    //fetchCertificateTypes();
  }, []);

 useEffect(() => {
  if (module !== ENUM_MODULES.REPORTS) return;

  setDataFilters([
    {
      filter: 'certificateType',
      value_filter: '',
      data: formatOptionsForSelect(names, 'name', 'name', 'Elegir tipo'),
      width: 'col-span-4 max-[768px]:col-span-12',
    },
    {
      filter: 'status',
      value_filter: '',
      data: CERTIFICATES_STATUS,
      width: 'col-span-3 max-[768px]:col-span-12',
    },
  ]);
}, [names, module, setDataFilters]);

useEffect(() => {
  if (module !== ENUM_MODULES.EMISSIONS) return;
  setDataFilters([
    {
      filter: 'status',
      value_filter: '',
      data: CERTIFICATES_STATUS,
      width: 'col-span-3 max-[768px]:col-span-12',
    },
    ...customerFilters,
  ]);
}, [customerFilters, module, setDataFilters]);

  return { ...table };
};
